import { useStore } from "@features/common"
import { useAmp } from "next/amp"

import { SmartBanner } from "../organisms"

export function useSmartBanner() {
  const {
    GlobalModel: { isSmartBannerOpened, isSmartBannerDisabled, smartBanner },
  } = useStore()
  const isAMP = useAmp()

  const showSmartBanner =
    !isSmartBannerDisabled &&
    isSmartBannerOpened &&
    smartBanner.description &&
    smartBanner.buttonText &&
    smartBanner.playmarketButtonText &&
    smartBanner.appgalleryButtonText &&
    !isAMP

  return {
    smartBanner: showSmartBanner ? <SmartBanner /> : null,
  }
}
